import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import useTrackPreviousPage from "../hooks/useTrackPreviousPage";
import TrialBanner from "./TrialBanner";
import { Box } from "@mui/material";
import { useSocket } from "../hooks/useSocket";
import { socketEventEmitter } from "../socket";
import { useProject } from "../context/ProjectContext";
import LoginIssueModal from "./modals/LoginIssueModal";
import ProjectService from "../services/ProjectService";

const AUTOMATIC_LOGIN_TASK_TYPES = new Set([
    "Login Elements Processing",
    "Login Test",
]);

const isAutomaticLoginIssue = (data) =>
    AUTOMATIC_LOGIN_TASK_TYPES.has(data?.type);

const Layout = () => {
    useSocket();
    useTrackPreviousPage();
    const { selectedProject } = useProject();
    const [loginIssueOpen, setLoginIssueOpen] = useState(false);
    const [loginIssueProjectId, setLoginIssueProjectId] = useState(null);
    const [loginIssueInitialLogin, setLoginIssueInitialLogin] = useState("");

    useEffect(() => {
        const handleTaskFailed = async (data) => {
            if (!isAutomaticLoginIssue(data)) return;

            const projectId =
                data.projectId || data.project_id || selectedProject?.id;

            setLoginIssueProjectId(projectId);
            setLoginIssueInitialLogin("");
            setLoginIssueOpen(true);

            if (!projectId) return;

            try {
                const loginData =
                    await ProjectService.getProjectLoginDataById(projectId);
                setLoginIssueInitialLogin(loginData?.login || "");
            } catch (error) {
                console.error("Failed to load login data for issue modal:", error);
            }
        };

        socketEventEmitter.on("taskFailed", handleTaskFailed);

        return () => {
            socketEventEmitter.off("taskFailed", handleTaskFailed);
        };
    }, [selectedProject?.id]);

    return (
        <Box className="rootWrapper">
            <TrialBanner />
            <Box className="srollContent">
                <Outlet />
            </Box>
            <LoginIssueModal
                open={loginIssueOpen}
                setOpen={setLoginIssueOpen}
                projectId={loginIssueProjectId || selectedProject?.id}
                initialLogin={loginIssueInitialLogin}
            />
        </Box>
    );
};

export default Layout;
